<template>
    <img v-if="imageObjectUrl" :src="imageObjectUrl" :alt="imageAlt" v-bind="$attrs"/>
</template>

<script>

export default {
    name: 'ImageDisplay',
    props: {
        imageId: {  // the id or hash relating to a file 
            type: [String, Number],
            required: true,
            validator: (value) => (typeof value == 'string') || Number.isInteger(value)
        }, 
        isThumb: {  // the id or hash relating to a file 
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            imageObjectUrl: false,
            imageAlt: ""
        }
    },
    watch: {
        imageId() {
            this.setImage()
        }
    },
    methods: {
        setImage() {
            if (!this.imageId)
                return

            const idKey = (typeof this.imageId == 'string') ? 'hash' : 'id'
            let payload = { [idKey]: this.imageId }

            if (this.isThumb)
                payload.thumb = true

            this.$getFileBlob(payload, true).then(([blob, fileName]) => {
                this.imageObjectUrl = URL.createObjectURL(blob)
                this.imageName = fileName
            }).catch((response) => {
                if ('message' in response && response.message)
                    this.imageAlt = response.message
            })
        }
    },
    created() {
        this.setImage()
    }
}
</script>

<style scoped>

img {
    width: 100%;
    height: 100%;
}

</style>
